import { CollapseInterface } from "../../../Interfaces/CollapseInterface";
import { RecordCatalogViewModel } from "../../../models/ViewModels/RecordCatalogViewModel";
import { RecordViewModel } from "../../../models/ViewModels/RecordViewModel";
import { CollapseGroup } from "../../../share/Components";
import RecordAbuseHistory from "./RecordAbuseHistory";
import RecordAdverseReaction from "./RecordAdverseReaction";
import RecordDrugHistory from "./RecordDrugHistory";
import RecordFamilyHistory from "./RecordFamilyHistory";
import RecordPastMedicalHistory from "./RecordPastMedicalHistory";
import RecordPatientHistory from "./RecordPatientHistory";

const RecordHistory = ({
  catalog,
  record,
  onItemChange,
}: {
  catalog?: RecordCatalogViewModel;
  record?: RecordViewModel;
  onItemChange?: (updatedItem: RecordViewModel) => void; // A function to handle item changes
}) => {
  const handlePatientHistoryChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      patientHistory: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const handlePastMedicalHistoryChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      pastMedicalHistory: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const handleFamilyHistoryChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      familyHistory: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const handleDrugHistoryChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      drugHistory: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const handleAbuseHistoryChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      abuseHistory: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const handleAdverseReactionChange = (updatedItem) => {
    const updateData: RecordViewModel = {
      ...record,
      adverseReaction: updatedItem,
    };
    onItemChange && onItemChange(updateData);
  };
  const arr: Array<CollapseInterface> = [
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primary ",
        className: "py-3 bg-white border border-primaryDefault2",
      },
      title: record?.pastMedicalHistory?.caption, // "سابقه پزشکی",
      isShow: record?.pastMedicalHistory?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordPastMedicalHistory
          catalog={catalog?.pastmedicalHistory}
          item={record?.pastMedicalHistory}
          onItemChange={handlePastMedicalHistoryChange}
        />
      ),
    },
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primaryLight",
        className: "py-3 bg-white border border-primaryDefault2",
      },
      title: record?.patientHistory?.caption, // "سابقه ی بیماری",
      isShow: record?.patientHistory?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordPatientHistory
          catalogs={catalog?.patientHistory}
          item={record?.patientHistory}
          onItemChange={handlePatientHistoryChange}
        />
      ),
    },
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primary ",
        className: "py-3 bg-white border border-primaryDefault2 ",
      },
      title: record?.familyHistory?.caption, // "سابقه خانوادگی",
      isShow: record?.familyHistory?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordFamilyHistory
          catalogs={catalog?.familyHistory}
          relatives={catalog?.relativePerson}
          item={record?.familyHistory}
          onItemChange={handleFamilyHistoryChange}
        />
      ),
    },
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primary ",
        className: "py-3 bg-white border border-primaryDefault2 ",
      },
      title: record?.drugHistory?.caption, // "سابقه دارویی",
      isShow: record?.drugHistory?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordDrugHistory
          item={record?.drugHistory}
          onItemChange={handleDrugHistoryChange}
        />
      ),
    },
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primary ",
        className: "py-3 bg-white border border-primaryDefault2 ",
      },
      title: record?.adverseReaction?.caption, // "حساسیت دارویی",
      isShow: record?.adverseReaction?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordAdverseReaction
          reactions={catalog?.reactionCategory}
          severities={catalog?.severity}
          item={record?.adverseReaction}
          onItemChange={handleAdverseReactionChange}
        />
      ),
    },
    {
      icon: "rayteb-rx",
      className: {
        iconClass: "!text-3xl !text-disable ",
        titleClass: "!font-bold !text-sm !text-primary ",
        className: "py-3 bg-white border border-primaryDefault2 ",
      },
      title: record?.abuseHistory?.caption, // "تاریخچه ی مصرف مواد مخدر",
      isShow: record?.abuseHistory?.isShow!,
      classNameOnSelected: "!bg-secondaryLight",
      element: (
        <RecordAbuseHistory
          abuseItems={catalog?.abuseHistory}
          timeUnits={catalog?.timeUnit}
          item={record?.abuseHistory}
          onItemChange={handleAbuseHistoryChange}
        />
      ),
    },
  ];
  return (
    <>
      <div className="pb-20  w-[95%] m-auto  ">
        <CollapseGroup items={arr} />
      </div>
    </>
  );
};

export default RecordHistory;
